import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Grid,
  Typography,
} from "@mui/material";

import imaage1 from "../../../assets/img/Home/Imaage1.svg";
import Rec from "../../../assets/img/Home/RecL.svg";
import { useNavigate } from 'react-router-dom';

const CarCard = () => {
  const navigate = useNavigate();
  return (
    <Card
      sx={{
        padding: "9px",
        borderRadius: "20px",
        backgroundColor: "#fff",
        
      }}
    >
      <CardActionArea>
        
        <CardMedia component="img" image={Rec} alt="car" onClick={() => navigate('/details')}/>
        
        <CardContent sx={{ padding: "0px" }}>
          
          <Typography
            gutterBottom
            component="div"
            sx={{
              fontSize: 10,
              color: "#6B767F",
              fontWeight: 400,
              lineHeight: "9px",
              fontFamily: "Poppins, sans-serif",
              paddingTop: "12px",
              
            }}
          >
            Automotive | Collectable Car | Super Car
          </Typography>
          <Typography
          
            sx={{
              fontSize: 16,
              color: "#242424",
              fontWeight: 600,
              lineHeight: "16px",
              fontFamily: "Poppins, sans-serif",
              paddingTop: "8px",
              paddingBottom: "12px",
              borderBottom: "1px solid #CBCFD2",

            }}
          >
            2012 Lexus LFA
          </Typography>
          <Box
  sx={{
    backgroundColor: "#fff", 
    borderRadius: "9px",
    padding: "17px 9px 9px",
    marginTop: "12px",
    border: "1px solid #000" 
  }}
>
  <Typography
    sx={{
      fontSize: 14,
      color: "#000",
      fontWeight: 600,
      lineHeight: "14px",
      fontFamily: "Poppins, sans-serif",
    }}
  >
    $3.67
  </Typography>
  <Typography
    sx={{
      fontSize: 10,
      color: "#000", 
      fontWeight: 600,
      fontFamily: "Inter, sans-serif",
    }}
  >
    Price Per Share
  </Typography>
</Box>
          <Grid container alignItems="start" columnSpacing={"5px"} pt={"6px"}>
            <Grid item xs={6}>
              <div
                style={{
                  border: "1px solid black",
                  borderRadius: "7px",
                  padding: "12px 9px 7px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: 14,
                    color: "#242424",
                    fontWeight: 600,
                    lineHeight: "14px",
                    fontFamily: "Poppins, sans-serif",
                  }}
                >
                  $300,000{" "}
                </Typography>
                <Typography
                  sx={{
                    fontSize: 10,
                    color: "#242424",
                    fontWeight: 600,
                    fontFamily: "Inter, sans-serif",
                  }}
                >
                  Initial Price Offering
                </Typography>
              </div>
            </Grid>
            <Grid item xs={6}>
              <div
                style={{
                  border: "1px solid #242424",
                  borderRadius: "7px",
                  padding: "12px 9px 7px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: 14,
                    color: "#242424",
                    fontWeight: 600,
                    lineHeight: "14px",
                    fontFamily: "Poppins, sans-serif",
                  }}
                >
                  2010 - 2012{" "}
                </Typography>
                <Typography
                  sx={{
                    fontSize: 10,
                    color: "#242424",
                    fontWeight: 600,
                    fontFamily: "Inter, sans-serif",
                  }}
                >
                  Production Years
                </Typography>
              </div>
            </Grid>
            <Grid item xs={3} pt={"6px"}>
              <div
                style={{
                  border: "1px solid #242424",
                  borderRadius: "7px",
                  padding: "12px 9px 7px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: 14,
                    color: "#242424",
                    fontWeight: 600,
                    lineHeight: "14px",
                    fontFamily: "Poppins, sans-serif",
                  }}
                >
                  553hp
                </Typography>
                <Typography
                  sx={{
                    fontSize: 7,
                    color: "#242424",
                    fontWeight: 600,
                    fontFamily: "Inter, sans-serif",
                  }}
                >
                  Total Horsepower
                </Typography>
              </div>
            </Grid>
            <Grid item xs={3} pt={"6px"}>
              <div
                style={{
                  border: "1px solid #242424",
                  borderRadius: "7px",
                  padding: "12px 9px 7px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: 14,
                    color: "#242424",
                    fontWeight: 600,
                    lineHeight: "14px",
                    fontFamily: "Poppins, sans-serif",
                  }}
                >
                  4.8L V10
                </Typography>
                <Typography
                  sx={{
                    fontSize: 7,
                    color: "#242424",
                    fontWeight: 600,
                    fontFamily: "Inter, sans-serif",
                  }}
                >
                  Engine
                </Typography>
              </div>
            </Grid>
            <Grid item xs={3} pt={"6px"}>
              <div
                style={{
                  border: "1px solid #242424",
                  borderRadius: "7px",
                  padding: "12px 9px 7px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: 14,
                    color: "#242424",
                    fontWeight: 600,
                    lineHeight: "14px",
                    fontFamily: "Poppins, sans-serif",
                  }}
                >
                  203 mph
                </Typography>
                <Typography
                  sx={{
                    fontSize: 7,
                    color: "#242424",
                    fontWeight: 600,
                    fontFamily: "Inter, sans-serif",
                  }}
                >
                  Top Speed
                </Typography>
              </div>
            </Grid>
            <Grid item xs={3} pt={"6px"}>
              <div
                style={{
                  border: "1px solid #242424",
                  borderRadius: "7px",
                  padding: "12px 9px 7px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: 14,
                    color: "#242424",
                    fontWeight: 600,
                    lineHeight: "14px",
                    fontFamily: "Poppins, sans-serif",
                  }}
                >
                  500
                </Typography>
                <Typography
                  sx={{
                    fontSize: 7,
                    color: "#242424",
                    fontWeight: 600,
                    fontFamily: "Inter, sans-serif",
                  }}
                >
                  Worldwide Rarity
                </Typography>
              </div>
            </Grid>
          </Grid>
          <Grid
            container
            alignItems="start"
            columnSpacing={"8px"}
            pt={"20px"}
            pb={"8px"}
          >
            <Grid item xs={6}>
              <Button
                style={{
                  backgroundColor: "#343330",
                  borderRadius: "6px",
                  width: "100%",
                  padding: "10px 0px",
                }}
                onClick={() => navigate('/invest')}
              >
                <Typography
                  sx={{
                    fontSize: 14,
                    color: "#fff",
                    fontWeight: 400,
                    lineHeight: "14px",
                    fontFamily: "Poppins, sans-serif",
                  }}
                >
                  Invest Now
                </Typography>
              </Button>
            </Grid>
            <Grid item xs={6}>
      <Button
        style={{
          border: "1px solid #242424",
          borderRadius: "6px",
          width: "100%",
          padding: "9px 0px",
        }}
        onClick={() => navigate('/details')}
      >
        <Typography
          sx={{
            fontSize: 14,
            color: "#242424",
            fontWeight: 400,
            lineHeight: "14px",
            fontFamily: "Poppins, sans-serif",
          }}
        >
          Learn More
        </Typography>
      </Button>
    </Grid>
          </Grid>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default CarCard;
